var _style, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHelpContact = function SvgHelpContact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "help-contact_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 500 500"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".help-contact_svg__st2{fill:#0054a6}")), /*#__PURE__*/React.createElement("path", {
    d: "M-1.1.2h500.3v500.5H-1.1z",
    style: {
      fill: "#fd0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m112.2 403.4 43.8-46.2c3.9-2.3 8.3-3.5 12.8-3.5h200.4c15 0 27.1-13.2 27.1-29.5v-151c0-16.3-12.1-29.5-27.1-29.5H130.7c-15 0-27.1 13.2-27.1 29.5v224.6c0 4.8 4.7 7.9 8.6 5.6z",
    style: {
      fill: "none",
      stroke: "#0054a6",
      strokeWidth: 14,
      strokeMiterlimit: 10
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 181.2,
    cy: 243.7,
    r: 20.4,
    className: "help-contact_svg__st2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 251.8,
    cy: 243.7,
    r: 20.4,
    className: "help-contact_svg__st2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 322.4,
    cy: 243.7,
    r: 20.4,
    className: "help-contact_svg__st2"
  })));
};
export default SvgHelpContact;